import React from 'react';
import { useTranslation } from 'react-i18next';
import NoResultFound from './NoResultFound';
import { BaseButton } from 'app/components/buttons/BaseButton';

interface Props {
  isFilterUsed: boolean;
  onClear: () => void;
  className?: string;
}

export default function TableNoResults({
  isFilterUsed,
  onClear,
  className,
}: Props) {
  const { t } = useTranslation();

  return (
    <NoResultFound
      className={className}
      title={t('access_sharing.table.no_results.title')}
      description={
        isFilterUsed
          ? t('access_sharing.table.no_results.remove_or_clear_all_filters')
          : t('access_sharing.table.no_results.try_different_keyword')
      }
      action={
        isFilterUsed && (
          <BaseButton onClick={onClear} className="no-result-found__button">
            {t('access_sharing.table.no_results.clear_all_filters')}
          </BaseButton>
        )
      }
    />
  );
}
